import { render, staticRenderFns } from "./TobaccoUsage.vue?vue&type=template&id=401922ee&scoped=true"
import script from "./TobaccoUsage.vue?vue&type=script&lang=js"
export * from "./TobaccoUsage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "401922ee",
  null
  
)

export default component.exports